import { BASE_URL, get, post, useFetch } from 'utils/sdk';
import { formatGetParams } from 'utils/utilsV2';
import { IntegrationType } from 'api/types/partners';

export interface IStoreToSync {
  id: number;
  store_name: string;
  import_sources: Array<{ platform: string; platform_id: string }>;
  is_connected_platform: boolean;
}

export interface IStoreIntegration {
  platform: IntegrationType;
  platform_id: number;
  is_imported_source: boolean;
  date_created: string;
}

export const storeReorderProducts = ({
  storeId,
  productsPositions,
}: {
  storeId: number;
  productsPositions: Array<{
    id: number;
    position: number;
  }>;
}) =>
  post(`${BASE_URL}services/store/${storeId}/reorder-products/`, {
    positions: productsPositions,
  });

export const saveStoreOwnerProfitPercentage = ({
  storeId,
  ownerProfitPercentage,
  saveToAllStores,
}: {
  storeId: number;
  ownerProfitPercentage: number;
  saveToAllStores: boolean;
}) => {
  return post(`${BASE_URL}services/store/${storeId}/set-owner-profit-percentage/`, {
    owner_profit_percentage: ownerProfitPercentage,
    save_to_all_stores: saveToAllStores,
  });
};

// For polling if the mass store request is finished
export const getMassStoreStatus = ({ massStoreRequestId }: { massStoreRequestId: number }) =>
  // We don't need to know the actual requst data
  get<{ is_finished: boolean; request: Array<{}> }>(
    `${BASE_URL}services/store/mass-store-request/${massStoreRequestId}/`,
  );

export const useStoresToSync = ({ platform }: { platform: IntegrationType }) =>
  useFetch<Array<IStoreToSync>>(
    `services/store/stores-to-sync/${formatGetParams({
      platform,
    })}`,
  );

export const useStoreIntegrations = ({ storeId, enabled }: { storeId: number; enabled: boolean }) =>
  useFetch<Array<IStoreIntegration>>(
    enabled ? `services/store/${storeId}/integrations/` : undefined,
  );

export const setStoreVisibility = ({
  storeId,
  isVisible,
}: {
  storeId: number;
  isVisible: boolean;
}) => {
  return post(`${BASE_URL}services/store/${storeId}/set-visibility/`, {
    is_visible: isVisible,
  });
};
